module.exports = __webpack_public_path__ + "33ea0ad39707fafcaaf78f1a55505f7b.svg";